import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="py-10 text-center text-brand-body/60 text-sm border-t border-brand-sage bg-brand-cream" data-id="element-14">
        <div className="container mx-auto px-4 flex flex-col items-center gap-4" data-id="element-15">
          <div className="flex flex-wrap justify-center gap-6 text-brand-body/80" data-id="element-16">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-navy transition-colors underline-offset-4 hover:underline" data-id="element-17">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-navy transition-colors underline-offset-4 hover:underline" data-id="element-18">
              Terms of Service
            </button>
          </div>
          <p data-id="element-19">
            © {new Date().getFullYear()} The Reconciliation Roadmap. All rights
            reserved.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-brand-navy/40 backdrop-blur-sm" onClick={closeModal} aria-modal="true" role="dialog" data-id="element-20">
          <div className="bg-white rounded-[2rem] w-full max-w-3xl max-h-[85vh] overflow-hidden shadow-2xl flex flex-col relative border border-brand-sage animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-21">
            {/* Header */}
            <div className="flex justify-between items-center p-6 md:p-8 border-b border-brand-sage/50 bg-brand-cream/30" data-id="element-22">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-navy" data-id="element-23">
                {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
              </h2>
              <button onClick={closeModal} className="p-2 rounded-full hover:bg-brand-sage/50 transition-colors text-brand-body bg-white shadow-sm border border-brand-sage/50" aria-label="Close modal" data-id="element-24">
                <X className="w-5 h-5" data-id="element-25" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 md:p-8 overflow-y-auto bg-white flex-1 text-brand-body text-left" data-id="element-26">
              {activeModal === 'privacy' ? <div className="space-y-5" data-id="element-27">
                  <p className="text-sm text-brand-body/60 italic" data-id="element-28">
                    Last updated: {new Date().toLocaleDateString()}
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-29">
                    1. Information We Collect
                  </h3>
                  <p className="leading-relaxed" data-id="element-30">
                    We collect information you provide directly to us when you
                    make a purchase, sign up for our newsletter, or otherwise
                    interact with our platform. This may include your name,
                    email address, and payment information.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-31">
                    2. How We Use Your Information
                  </h3>
                  <p className="leading-relaxed" data-id="element-32">
                    We use the information we collect to deliver the products
                    you have purchased, send you technical notices and support
                    messages, and communicate with you about products, services,
                    and events. We process this data to ensure you have the best
                    possible experience with our materials.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-33">
                    3. Information Sharing
                  </h3>
                  <p className="leading-relaxed" data-id="element-34">
                    We do not share your personal information with third parties
                    except as necessary to provide our services (such as
                    processing payments securely through our payment providers)
                    or as required by law.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-35">
                    4. Data Security
                  </h3>
                  <p className="leading-relaxed" data-id="element-36">
                    We take reasonable and appropriate measures to help protect
                    information about you from loss, theft, misuse, unauthorized
                    access, disclosure, alteration, and destruction. Your data
                    privacy is a top priority.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-37">
                    5. Your Rights
                  </h3>
                  <p className="leading-relaxed" data-id="element-38">
                    You may update, correct, or request deletion of your account
                    information at any time. You may also opt out of receiving
                    promotional communications from us by following the
                    instructions in those communications.
                  </p>
                </div> : <div className="space-y-5" data-id="element-39">
                  <p className="text-sm text-brand-body/60 italic" data-id="element-40">
                    Last updated: {new Date().toLocaleDateString()}
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-41">
                    1. Acceptance of Terms
                  </h3>
                  <p className="leading-relaxed" data-id="element-42">
                    By accessing and using this website and purchasing our
                    digital products, you accept and agree to be bound by the
                    terms and provision of this agreement. If you do not agree
                    to abide by these terms, please do not use this service.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-43">
                    2. Intellectual Property
                  </h3>
                  <p className="leading-relaxed" data-id="element-44">
                    All content included on this site, such as text, graphics,
                    logos, images, audio clips, digital downloads, and data
                    compilations is the property of The Reconciliation Roadmap
                    or its content suppliers and protected by international
                    copyright laws. The materials provided are for your personal
                    use only.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-45">
                    3. Use License
                  </h3>
                  <p className="leading-relaxed" data-id="element-46">
                    Permission is granted to temporarily download one copy of
                    the materials (information or software) for personal,
                    non-commercial transitory viewing only. This is the grant of
                    a license, not a transfer of title. You may not modify,
                    copy, distribute, transmit, display, perform, reproduce,
                    publish, license, create derivative works from, transfer, or
                    sell any information obtained from the materials.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-47">
                    4. Disclaimer
                  </h3>
                  <p className="leading-relaxed" data-id="element-48">
                    The materials on our website are provided on an 'as is'
                    basis. We make no warranties, expressed or implied, and
                    hereby disclaim and negate all other warranties including,
                    without limitation, implied warranties or conditions of
                    merchantability, fitness for a particular purpose, or
                    non-infringement of intellectual property or other violation
                    of rights. The information provided is for educational
                    purposes and does not constitute professional psychological
                    or legal advice.
                  </p>

                  <h3 className="font-heading font-bold text-xl text-brand-navy mt-8" data-id="element-49">
                    5. Limitations
                  </h3>
                  <p className="leading-relaxed" data-id="element-50">
                    In no event shall we or our suppliers be liable for any
                    damages (including, without limitation, damages for loss of
                    data or profit, or due to business interruption) arising out
                    of the use or inability to use the materials on our website,
                    even if we have been notified orally or in writing of the
                    possibility of such damage.
                  </p>
                </div>}
            </div>
          </div>
        </div>}
    </>;
}